import React from "react";
import { Check } from "lucide-react";
import { useI18n } from "../../lib/i18n";

// "Why Joshi FusionTech Media" — premium two-column layout with
// gradient ambient orange in the corner and large headline left,
// numbered/checked points right.
export const WhyChooseUs = () => {
  const { t } = useI18n();
  const w = t.whyUs;

  return (
    <section
      data-testid="why-us"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      {/* Ambient backdrop */}
      <div
        aria-hidden
        className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-brand-orange/[0.10] blur-[120px] pointer-events-none"
      />

      <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        {/* Left — headline */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-brand-orange" />
            <span className="label-mono">{w.kicker}</span>
          </div>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-[56px] tracking-tight text-white leading-[1.05]">
            {w.title}
          </h2>
          <p className="mt-7 text-white/65 text-lg leading-relaxed max-w-md">
            {w.intro}
          </p>
        </div>

        {/* Right — benefit list */}
        <div className="lg:col-span-7">
          <ul className="space-y-2">
            {w.points.map((p, i) => (
              <li
                key={i}
                className="
                  group flex items-start gap-5
                  py-6 border-b border-white/[0.06]
                  transition-colors duration-300
                  hover:border-brand-orange/30
                "
              >
                <div className="
                  w-11 h-11 shrink-0 rounded-xl
                  bg-brand-orange/[0.10] border border-brand-orange/[0.25]
                  flex items-center justify-center
                  transition-all duration-300
                  group-hover:bg-brand-orange/20 group-hover:scale-105
                ">
                  <Check className="w-5 h-5 text-brand-orange" strokeWidth={2.6} />
                </div>
                <div className="flex-1 pt-1">
                  <h3 className="font-display font-bold text-white text-xl tracking-tight">
                    {p.t}
                  </h3>
                  <p className="mt-2 text-white/60 text-[15px] leading-relaxed">
                    {p.d}
                  </p>
                </div>
                <span className="font-mono text-[11px] text-white/30 pt-2 tracking-wider">
                  0{i + 1}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
